import normalizeStyle from '@style/normalize.css?raw'
import style from './index.css?raw'

const template = document.createElement('template')
template.innerHTML = `
  <style>
    ${normalizeStyle}
    ${style}
  </style>
  <div class="jky-container" data-style="dark">
    <div class="text-wrap">
      <div class="title"></div>
      <div class="description"></div>
    </div>
    <div class="icon-wrap"></div>
  </div>
`

class ProductExtraText extends HTMLElement {
  constructor() {
    super()

    this.attachShadow({ mode: 'open' })
    this.shadowRoot.appendChild(template.content.cloneNode(true))
    
    // 绑定方法
    this.variantChangeHandler = this.variantChangeHandler.bind(this)
    this.toggleClick = this.toggleClick.bind(this)
    
    // 初始化DOM引用
    this.container = this.shadowRoot.querySelector('.jky-container')
    this.textWrap = this.shadowRoot.querySelector('.text-wrap')
    this.iconWrap = this.shadowRoot.querySelector('.icon-wrap')
    this.titleDOM = this.shadowRoot.querySelector('.title')
    this.descriptionDOM = this.shadowRoot.querySelector('.description')
    
    // 初始化状态
    this.isAnimating = false

    this.configData = JSON.parse(this.querySelector('script[type="application/json"]')?.textContent || '[]').sort((a, b) => a.order - b.order)
  }
  connectedCallback() {
    // 当前 变体id
    const currentVariantId = this.getAttribute('data-current-variant-id')
    
    // 检测是否显示
    this.checkVisibility(currentVariantId)

    // 监听变体切换
    if (document.querySelector('variant-fields')) {
      document.addEventListener('variantChangeEvent', this.variantChangeHandler)
    }
  }
  disconnectedCallback() {
    // 移除变体切换事件监听
    if (this.variantChangeHandler) {
      document.removeEventListener('variantChangeEvent', this.variantChangeHandler)
    }
    
    // 移除 iconWrap 的点击事件监听
    if (this.iconWrap) {
      const arrow = this.iconWrap.querySelector('.arrow')
      if (arrow) {
        arrow.removeEventListener('click', this.toggleClick)
      }
    }
  }
  // 变体切换事件
  variantChangeHandler(e) {
    const currentVariant = e.detail.variant
    if (currentVariant) {
      // 检测显示
      this.checkVisibility(currentVariant.id)
    }
  }
  // 检查title 内容高度
  checkTitleHeight(title) {
    this.titleDOM.innerHTML = title

    // 获取 真实渲染高度
    const rect = this.titleDOM.getBoundingClientRect();
    const actualHeight = rect.height;
    
    // 获取容器初始最小高度（根据媒体查询不同）
    let containerMinHeight
    if (window.innerWidth >= 1440) {
      containerMinHeight = 88 // 对应1440px以上的min-height: 88px
    } else if (window.innerWidth >= 1024) {
      containerMinHeight = 6.11111111111111 * window.innerWidth / 100 // 对应1024px以上的min-height: 6.11111111111111vw
    } else {
      containerMinHeight = 24 * window.innerWidth / 100 // 对应移动端的min-height: 24vw
    }
    
    // 如果内容高度大于容器初始最小高度，则调整样式
    if (actualHeight > containerMinHeight) {
      const richTextElement = this.titleDOM.querySelector('.metafield-rich_text_field')
      if (richTextElement) {
        richTextElement.style.display = '-webkit-box'
      }
    }
  }
  // 检测显示
  checkVisibility(currentVariantId) {
    // 如果没有 currentVariantId，直接隐藏
    if (!currentVariantId) {
      this.container.style.display = 'none'
      return
    }
    
    // 确保类型一致性，将两边都转换为字符串进行比较
    const variantIdStr = String(currentVariantId)

    let currentMatched = null
    for (let i = 0; i < this.configData.length; i++) {
      const item = this.configData[i]
      if (String(item.product_sku_id).split(',').map(String).includes(variantIdStr)) {
        currentMatched = item
        break
      }
    }

    // 如果有匹配的配置项，则显示并设置相应内容，否则隐藏
    if (currentMatched) {
      this.container.style.display = 'flex'

      this.container.style = `
        --title-color: ${currentMatched.title_color};
        --title-highlight-color: ${currentMatched.title_highlight_color};
        --description-color: ${currentMatched.description_color};
        --description-highlight-color: ${currentMatched.description_highlight_color};
      `

      // 还原状态
      this.container.classList.remove('unfold')

      // 初始化 icon DOM
      this.initIconDOM(currentMatched.icon)

      // 直接将 max-height 设置为折叠时的高度
      this.textWrap.style.maxHeight = `${this.collapsedMaxHeight}px`
      this.iconWrap.querySelector('.arrow').style.transform = 'rotate(0deg)'

      // 配置的风格，iconLink
      const colorStyle = currentMatched.style || 'dark'
      // 设置容器样式
      this.container.setAttribute('data-style', colorStyle)

      // 更新 title 内容高度并调整样式
      this.checkTitleHeight(currentMatched.title)

      // 更新 description 内容
      this.descriptionDOM.innerHTML = currentMatched.description
      
      // 折叠状态下的最大高度 - 必须在DOM连接后计算
      this.collapsedMaxHeight = this.textWrap.offsetHeight
    } else {
      this.container.style.display = 'none'
    }
  }
  initIconDOM(iconLink) {
    this.iconWrap.innerHTML = this.renderIconWrap(iconLink)

    // 注册 click 事件
    this.iconWrap.addEventListener('click', this.toggleClick)
  }
  renderIconWrap(iconLink) {
    return `
      <svg class="arrow" width="56" height="56" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
          <path d="M27.88 40.753a2.3 2.3 0 001.686-.734l19.487-20.07a2.22 2.22 0 00.68-1.62c0-.44-.1-.836-.302-1.19a2.228 2.228 0 00-.818-.835A2.265 2.265 0 0047.442 16c-.621 0-1.167.22-1.637.658L26.52 36.475h2.694L9.928 16.658A2.268 2.268 0 008.29 16c-.436 0-.827.101-1.17.304-.345.202-.617.48-.819.835-.201.354-.302.75-.302 1.19a2.287 2.287 0 00.68 1.645l19.487 20.045c.504.489 1.074.734 1.712.734z" fill="currentColor" fill-rule="nonzero"></path>
          <path d="M0 0h56v56H0z"></path>
        </g>
      </svg>
      <img src="${iconLink}" alt="" loading="lazy">
    `
  }
  toggleClick() {
    if (this.isAnimating) return
    this.isAnimating = true

    const isCurrentlyUnfolded = this.container.classList.contains('unfold')
    const arrow = this.iconWrap.querySelector('.arrow')

    if (!isCurrentlyUnfolded) {
      // 更新 container 样式
      this.container.classList.add('unfold')
      
      // 准备展开：移除 line-clamp 以便测量完整内容高度
      const expandedScrollHeight = this.textWrap.scrollHeight
      
      // 设置 max-height 以触发展开动画
      this.textWrap.style.maxHeight = `${expandedScrollHeight}px`
      arrow.style.transform = 'rotate(180deg)'
    } else {
      // 准备收起
      // 直接将 max-height 设置为折叠时的高度以触发收起动画
      this.textWrap.style.maxHeight = `${this.collapsedMaxHeight}px`
      arrow.style.transform = 'rotate(0deg)'
    }

    const onTransitionEnd = (e) => {
      // 确保只处理 max-height 属性的过渡结束事件
      if (e.propertyName !== 'max-height') return
      
      this.textWrap.removeEventListener('transitionend', onTransitionEnd)

      if (isCurrentlyUnfolded) { 
        this.container.classList.remove('unfold')
      }
      this.isAnimating = false
    }
    this.textWrap.addEventListener('transitionend', onTransitionEnd)
  }
}

customElements.define('product-extra-text', ProductExtraText)
